import React, { useCallback } from 'react';

import { Box, useTheme } from '@mui/material';
import { AlertList, AlertListItem } from '../../../../_mui/_alerts_/NotificationAlert';
import { useUploadModal } from '../../UploadModalContext';

const AlertBody: React.FC = () => {
  const theme = useTheme();
  const { profile } = useUploadModal();
  const preparingCsvAlert = profile.copy.preparingCsvAlert;

  const boldTextWrapper = useCallback((children: React.ReactNode) => {
    return (
      <Box component="span" sx={{ fontWeight: theme.typography.fontWeightMedium }}>
        {children}
      </Box>
    );
  }, []);

  return (
    <AlertList sx={{ pt: 0, pb: 2 }}>
      <AlertListItem>
        {boldTextWrapper(preparingCsvAlert.headersDescription)} {preparingCsvAlert.requiredHeaders}
      </AlertListItem>
      <AlertListItem>
        {boldTextWrapper(preparingCsvAlert.requiredRowsDescriptionBold)} {preparingCsvAlert.requiredRowsDescription}
      </AlertListItem>
    </AlertList>
  );
};

export default AlertBody;
